module.exports = __webpack_public_path__ + "img/num2.4c9a1ee8.jpg";